import { useEffect } from "react";
import { useInspectionId } from "../hooks/useInspectionId";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../hooks/storeHooks";
import { fetchInspectionData } from "../store/thunks/inspectionThunks";
import { fetchDocumentElements } from "../store/thunks/documentThunks";
import { selectInspection } from "../store/selectors/inspectionSelectors";
import { selectDocuments } from "../store/selectors/documentSelectors";
import { ProgressSpinner } from "primereact/progressspinner";
import { Card } from "primereact/card";
import { DocumentDisplayTable } from "@idwal/idwal-react-components";
import { InspectionInfoCard } from "../components/Inspection/InspectionInfoCard";
import { PageHeader } from "../components/Shared/PageHeader";

const Documents = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation("locale");

  const { inspection, loading, error } = useAppSelector(selectInspection);
  const documents = useAppSelector(selectDocuments);

  const inspectionId = useInspectionId();

  useEffect(() => {
    if (inspectionId) {
      dispatch(fetchInspectionData(inspectionId));
      dispatch(fetchDocumentElements(inspectionId));
    }
  }, [inspectionId]);

  if (loading || documents.loading) {
    return (
      <div className="flex h-full align-items-center justify-content-center">
        <ProgressSpinner />
      </div>
    );
  }

  if (error || !inspection) {
    return (
      <div className="flex align-items-center justify-content-center">
        <p>{t("documents.inspectionLoadFailed")}</p>
      </div>
    );
  }

  return (
    <div className="flex flex-column gap-3">
      <PageHeader title={t("documents.title")} />
      <InspectionInfoCard thirdColumn="status" />
      <Card>
        {documents.error ? (
          <p>{t("documents.loadFailed")}</p>
        ) : (
          <DocumentDisplayTable
            rows={documents.documentElements}
            nameHeader={t("documents.table.name")}
            countHeader={t("documents.table.submitted")}
            addedHeader={t("documents.table.oldestUpload")}
            actionsHeader={t("documents.table.actions")}
            emptyMessage={t("documents.table.noDocumentTypes")}
          />
        )}
      </Card>
    </div>
  );
};

export default Documents;
